class SubscriptionWidget extends HTMLElement {
    storedPurchaseType = null;
    storedSellingPlanId = null;
    constructor() {
        super();

        this.handlePurchaseTypeChange = this.handlePurchaseTypeChange.bind(this);
        this.updateSellingPlanPrice = this.updateSellingPlanPrice.bind(this);
        this.variantChangeHandler = this.variantChangeHandler.bind(this);
    }

    connectedCallback() {
        this.initWidget();

        const variantInput = document.querySelector(".product-variant-id");
        if (variantInput) {
            variantInput.addEventListener("change", this.variantChangeHandler);
        }
    }

    disconnectedCallback() {
        this.removeWidgetEvents();

        const variantInput = document.querySelector(".product-variant-id");
        if (variantInput) {
            variantInput.removeEventListener("change", this.variantChangeHandler);
        }
    }

    /* ---------------------------
       Initialize widget
    ---------------------------- */
    initWidget() {
        this.purchaseTypeInputs = this.querySelectorAll('input[name="purchase-type"]');
        this.sellingPlanInputs = this.querySelectorAll('input[name="selling_plan"]');

        this.purchaseTypeInputs.forEach(input =>
            input.addEventListener("change", this.handlePurchaseTypeChange)
        );

        this.sellingPlanInputs.forEach(input =>
            input.addEventListener("change", this.updateSellingPlanPrice)
        );

        // Auto-enable subscription if user clicks a delivery option
        this.sellingPlanInputs.forEach(input => {
            input.addEventListener("click", () => {
                const subscribeRadio = this.querySelector('input[name="purchase-type"][value="subscribe"]');
                if (subscribeRadio) {
                    subscribeRadio.checked = true;
                }
                input.checked = true;
                this.updateSellingPlanPrice();
            });
        });

        // If initial is "one-time" → uncheck selling plans
        const selectedType = this.querySelector('input[name="purchase-type"]:checked');
        if (selectedType && selectedType.value === "one-time") {
            this.uncheckSellingPlans();
        }

        this.updateSellingPlanPrice();
        var this_ = this;
        setTimeout(function () {
            this_.updateMainPrice(this_);
        }, 2000);
    }

    /* ---------------------------
       Remove widget listeners
    ---------------------------- */
    removeWidgetEvents() {
        if (this.purchaseTypeInputs) {
            this.purchaseTypeInputs.forEach(input =>
                input.removeEventListener("change", this.handlePurchaseTypeChange)
            );
        }

        if (this.sellingPlanInputs) {
            this.sellingPlanInputs.forEach(input =>
                input.removeEventListener("change", this.updateSellingPlanPrice)
            );
        }
    }

    /* ---------------------------
       Selling plan state helpers
    ---------------------------- */
    uncheckSellingPlans() {
        this.sellingPlanInputs.forEach(input => {
            input.checked = false;
        });
    }

    checkFirstSellingPlan() {
        if (this.sellingPlanInputs.length > 0) {
            this.sellingPlanInputs[0].checked = true;
        }
    }

    /* ---------------------------
       Update price based on selling plan
    ---------------------------- */
    updateSellingPlanPrice() {
        const selectedPlan = this.querySelector('input[name="selling_plan"]:checked');
        if (!selectedPlan) return;

        const sellingPlanId = selectedPlan.value;

        const jsonEl = document.getElementById("variant__json");
        if (!jsonEl) return;

        const variantDataStr = jsonEl.getAttribute("variant-data");
        if (!variantDataStr) return;

        const allocations = JSON.parse(variantDataStr).selling_plan_allocations;
        if (!allocations?.length) return;

        let newPrice = null;

        for (let alloc of allocations) {
            if (alloc.selling_plan_id == sellingPlanId) {
                if (alloc.price_adjustments?.length > 0) {
                    newPrice = alloc.price_adjustments[0].price;
                }
                break;
            }
        }

        if (newPrice !== null) {
            const formatted = (newPrice / 100).toFixed(2);

            const box = this.querySelector(".subscription-box.box-style");
            if (box) {
                const salePriceEl = box.querySelector(".sale_price_esa");
                if (salePriceEl) salePriceEl.textContent = "$" + formatted;
            }
        }
    }

    /* ---------------------------
       Purchase type changed
    ---------------------------- */
    handlePurchaseTypeChange(event) {
        const isOneTime = event.target.value === "one-time";

        if (isOneTime) {
            this.uncheckSellingPlans();
        } else {
            this.checkFirstSellingPlan();
            this.updateSellingPlanPrice();
        }
        var this_ = this;
        this.updateMainPrice(this_);
    }

    updateMainPrice(el) {
        const sectionId = el.dataset.sectionId;
        var isOneTime = el.querySelector('input[name="purchase-type"][value="one-time"]:checked');
        var regularPriceEl = document.querySelector(`#price-${sectionId} .price__regular`);
        var salePriceEl = document.querySelector(`#price-${sectionId} .price__sale`);
        var oneTimePrice = el.querySelector('.one-time-box .price').getAttribute('data-price');
        var oneTimeComparePrice = el.querySelector('.one-time-box .price').getAttribute('data-compare-price');
        var subscriptionPrice = el.querySelector('.subscription-box .price').getAttribute('data-price');
        if (isOneTime) {
            regularPriceEl.querySelector('.price-item--regular').textContent = oneTimePrice;
            salePriceEl.querySelector('.price-item--sale').textContent = oneTimePrice;
            if(oneTimeComparePrice) {
                salePriceEl.querySelector('.price-item--regular').textContent = oneTimeComparePrice;
            } else {
                document.querySelector(`#price-${sectionId} .price`).classList.remove('price--on-sale');
            }
        } else {
            document.querySelector(`#price-${sectionId} .price`).classList.add('price--on-sale');
            regularPriceEl.querySelector('.price-item--regular').textContent = subscriptionPrice;
            salePriceEl.querySelector('.price-item--regular').textContent = oneTimePrice;
            salePriceEl.querySelector('.price-item--sale').textContent = subscriptionPrice;
        }
    }

    /* ---------------------------
       Variant changed
    ---------------------------- */
    variantChangeHandler(event) {
        const variantId = event.target.value;

        const selectedPurchaseType = this.querySelector('input[name="purchase-type"]:checked');
        this.storedPurchaseType = selectedPurchaseType ? selectedPurchaseType.value : null;

        const selectedPlan = this.querySelector('input[name="selling_plan"]:checked');
        this.storedSellingPlanId = selectedPlan ? selectedPlan.value : null;

        const productUrl = this.dataset.productUrl;
        const sectionId = this.dataset.sectionId;

        this.updateSubscriptionWidget(productUrl, sectionId, variantId);
    }

    /* ---------------------------
       Fetch + Replace widget on variant change
    ---------------------------- */
    updateSubscriptionWidget(url, sectionId, variantId) {
        fetch(`${url}?variant=${variantId}&section_id=${sectionId}`)
        .then(res => res.text())
        .then(resText => {
            const doc = new DOMParser().parseFromString(resText, "text/html");
            const newWidget = doc.querySelector("#esa__subscription-widget");

            if (!newWidget) return;

            this.removeWidgetEvents();
            this.innerHTML = newWidget.innerHTML;
            this.sellingPlanInputs.forEach(input => {
                input.checked = false;
            });
            if (this.storedPurchaseType) {
                const storedPT = this.querySelector(
                    `input[name="purchase-type"][value="${this.storedPurchaseType}"]`
                );
                if (storedPT) storedPT.checked = true;
            }

            // Restore selling plan only if subscribe was previously selected
            if (
                this.storedPurchaseType === "subscribe" &&
                this.storedSellingPlanId
            ) {
                const storedPlan = this.querySelector(`input[name="selling_plan"][value="${this.storedSellingPlanId}"]`);
                if (storedPlan) {
                    storedPlan.checked = true;
                    this.updateSellingPlanPrice();
                }
            }
            this.initWidget();
        });
    }
}

customElements.define("subscription-widget", SubscriptionWidget);